import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { Role } from '../types/enumerated-types/roles';
import { OQContext } from '../types/organization-quarter-context';

@Injectable({
  providedIn: 'root'
})
export class QuarterSelectorService {
  selectedOQContext: OQContext = { org: null, qtr: null };
  selectedContextChange: Subject<OQContext> = new Subject<OQContext>();

  constructor(private readonly snackBar: MatSnackBar) {
    this.selectedContextChange.subscribe({ next: (value) => this.selectedOQContext = value });
  }

  public setSelectedContext(context: OQContext) {
    this.selectedContextChange.next(context);
  }

  public getCurrentRoleAsTitle() {
    return this.selectedOQContext.org ? this.getUserRoleAsTitle(this.selectedOQContext.org.role) : '';
  }

  public isInitialized():boolean {
    return this.selectedOQContext.org != null && this.selectedOQContext.qtr != null;
  }

  public getUserRoleAsTitle(userRole: number): string {
    switch (userRole) {
      case Role.P: return 'P';
      case Role.LP: return 'LP';
      case Role.LR: return 'LR';
      case Role.CR: return 'CR';
      case Role.RR: return 'RR';
      case Role.CFO: return 'CFO';
      case Role.DIR: return 'DIR';
      case Role.Admin: return 'Auditor';
      case Role.Auditor: return 'Auditor';
      default:
        return '';
    }
  }

  public displayOrgOrQtrChanged (message: string, timeAlive: number) {
    this.snackBar.open(message, '', {
      duration: timeAlive * 1000, // number is in milliseconds
      horizontalPosition: 'end',
      verticalPosition: 'bottom'
    });
  }

}
